import i18next from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import { ITranslationStrings } from '../types';
import { prepareLanguages } from '../utils/prepareLanguages';
import { prepareResources } from '../utils/prepareResources';

interface IConfigureTranslationsParams {
  strings: ITranslationStrings[];
  language: string;
  defaultLanguage?: string;
}

const main = i18next;

export function configureTranslations(params: IConfigureTranslationsParams): void {
  const { strings, language, defaultLanguage } = params;
  const { shortLanguage, shortDefaultLanguage } = prepareLanguages(language, defaultLanguage);

  const currentLanguage = shortLanguage || shortDefaultLanguage;
  const resources = prepareResources(strings, currentLanguage, shortDefaultLanguage);

  main
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      defaultNS: 'strings',
      lng: currentLanguage,
      fallbackLng: defaultLanguage,
      interpolation: {
        prefix: '{',
        suffix: '}',
        defaultVariables: { 0: '{0}', 1: '{1}', 2: '{2}', 3: '{3}' },
      },
    });
}

const { t } = main;

export { useTranslation, t };
